interface SectionInfoProps {
  description: string;
}

export function SectionInfo({ description }: SectionInfoProps) {
  return (
    <p className="text-sm text-muted-foreground -mt-1 mb-4">{description}</p>
  );
}
